import AggregationCards from './AggregationCards';

export default AggregationCards;
